// src/modules/app-views/_apps/appmulti/leads/pages/Document/tabs/FollowupTab/index.jsx
// *******************************************************************************
// IMPORTS
// *******************************************************************************
import { useState } from 'react';
import { Button, Flex, Input, Timeline } from 'antd';
import dayjs from 'dayjs';
import axiosService from 'services/axiosService';
import appService from 'services/appService';
import translateX from 'utils/translateX';
import useZustand from 'hooks/useZustand';
import { useDocumentContext } from 'components/core/DocumentProvider';
import { API } from 'constants/Api';

// *******************************************************************************
// MAIN COMPONENT
// *******************************************************************************
const FollowupTab = () => {
  // ─────────────────────────────────────────────────────────────────────────────
  // 1. PROPS, CONTEXTS & GLOBAL STATE
  // ─────────────────────────────────────────────────────────────────────────────
  const { data, refresh } = useDocumentContext();
  const user = useZustand('auth', 'user');

  // ─────────────────────────────────────────────────────────────────────────────
  // 2. HOOKS & REFS
  // ─────────────────────────────────────────────────────────────────────────────

  // ─────────────────────────────────────────────────────────────────────────────
  // 3. LOCAL VARIABLES I
  // ─────────────────────────────────────────────────────────────────────────────

  // ─────────────────────────────────────────────────────────────────────────────
  // 4. LOCAL STATE
  // ─────────────────────────────────────────────────────────────────────────────
  const [comment, setComment] = useState('');
  const [saving, setSaving] = useState(false);

  // ─────────────────────────────────────────────────────────────────────────────
  // 5. EFFECTS
  // ─────────────────────────────────────────────────────────────────────────────

  // ─────────────────────────────────────────────────────────────────────────────
  // 6. HANDLERS
  // ─────────────────────────────────────────────────────────────────────────────
  const onAddFollowup = async () => {
    if (!comment?.trim() || !data?._id) return;
    setSaving(true);
    try {
      const url = API.APPMULTI_LEADS.ADD_TO_SET
        .replace(':_id', data._id)
        .replace(':operator', '$push')
        .replace(':path', 'followUp');
      await axiosService.put({
        url,
        data: { accountId: user?._id, text: comment, reminderDate: null },
      });
      setComment('');
      if (typeof refresh === 'function') await refresh({ _id: data._id });
    } catch (err) {
      console.error('[FollowupTab] save error:', err);
      appService.message({ flag: 'e', text: 'error_saving' });
    } finally {
      setSaving(false);
    }
  };

  // ─────────────────────────────────────────────────────────────────────────────
  // 7. LOCAL VARIABLES II
  // ─────────────────────────────────────────────────────────────────────────────
  const items = [...(data?.followUp || [])]
    .sort((a, b) => dayjs(b?.createdAt).valueOf() - dayjs(a?.createdAt).valueOf())
    .map((f, i) => ({
      key: f?._id || i,
      title: (
        <div>
          {translateX('created_at')}: {f?.createdAt ? dayjs(f.createdAt).format('DD/MM/YYYY HH:mm:ss') : '—'}
        </div>
      ),
      content: (
        <div>
          {translateX('comment')}: {f?.text}
        </div>
      ),
    }));

  // ─────────────────────────────────────────────────────────────────────────────
  // 8. UI
  // ─────────────────────────────────────────────────────────────────────────────
  return (
    <Flex vertical gap={16} className="mw-720">
      <Input.TextArea
        rows={2}
        value={comment}
        placeholder={translateX('comment')}
        onChange={e => setComment(e.target.value)}
      />
      <div>
        <Button
          type="primary"
          loading={saving}
          disabled={!comment?.trim()}
          onClick={onAddFollowup}
        >
          {translateX('save')}
        </Button>
      </div>
      <Timeline mode="start" items={items} />
    </Flex>
  );
};

// *******************************************************************************
// EXPORT
// *******************************************************************************
export default FollowupTab;
